var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 88,
    viewBox: "0 0 153 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.1911 19.7895L6.37235 0.736789C5.41984 0.505055 4.41872 0.576807 3.509 0.942011C2.59928 1.30722 1.82644 1.94761 1.29856 2.77363C0.770688 3.59966 0.514174 4.57001 0.564894 5.54899C0.615613 6.52797 0.97103 7.46662 1.58144 8.23367L54.9468 75.8387C55.1706 76.1802 55.4844 76.4532 55.8535 76.6278C56.2225 76.8024 56.6326 76.8717 57.0386 76.8282C57.4446 76.7846 57.8306 76.6298 58.1542 76.3809C58.4778 76.1319 58.7265 75.7985 58.8727 75.4173L70.8278 51.2631C71.0561 50.7903 71.1211 50.2551 71.0128 49.7414C70.9044 49.2277 70.6287 48.7644 70.2289 48.4241L67.1015 46.073L74.5762 33.0532L79.2784 34.4506C79.6146 34.5646 79.9762 34.5813 80.3215 34.4989C80.6668 34.4165 80.9818 34.2383 81.2303 33.9848L91.0339 22.8947C91.2621 22.6627 91.4256 22.3749 91.508 22.0601C91.5904 21.7453 91.5889 21.4143 91.5037 21.1002C91.4184 20.7862 91.2524 20.4999 91.0221 20.2699C90.7918 20.04 90.5053 19.8743 90.1911 19.7895Z",
    fill: "#3098F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0594 45.6955L5.1084 4.75098",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2893 31.7885L5.04102 4.86182",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1914 40.3286C92.0096 45.7184 104.808 54.413 104.076 69.1628C103.809 74.242 97.6434 78.8999 93.163 72.0462C87.9063 64.017 93.4957 48.8014 111.55 54.3021C128.318 59.3148 141.804 72.0462 151.785 86.3967",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.3b9e0c09ee5bce03f738bf23712c0434.svg";
export { ForwardRef as ReactComponent };